export enum CardEmbedment {
  Carousel = 'carousel',
  Standalone = 'standalone',
}

export enum CardVariant {
  Owner = 'owner',
  Regular = 'regular',
}
